import React from 'react';
import { ActivityIndicator, TouchableOpacity, View } from 'react-native';
import { Icon, Image, Text } from '@rneui/themed';
import PropTypes from 'prop-types';

const AppLink = React.memo(props => {
    const heading = props.json?.heading;
    const description = props.json?.description;
    const image = props.json?.image?.cdnImagePath;
    const link = props.json?.link?.internalKey;

    return (
        <TouchableOpacity
            style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#fff',
                borderRadius: 6,
                borderColor: '#f5f5f5',
                borderWidth: 1,
                marginVertical: 8,
                marginHorizontal: 15
            }}
            onPress={() => props.followContentLink(false, link)}
        >
            <View>
                <Image
                    PlaceholderContent={<ActivityIndicator />}
                    source={{ uri: `https:${image}` }}
                    containerStyle={{
                        borderTopLeftRadius: 6,
                        borderBottomLeftRadius: 6,
                        height: 75,
                        width: 75
                    }}
                    resizeMode='cover'
                />
            </View>
            <View style={{ flex: 1, marginHorizontal: 10 }}>
                <Text
                    style={{
                        fontFamily: 'GothamMedium',
                        fontSize: 16
                    }}
                >
                    {heading}
                </Text>
                <Text
                    style={{
                        color: '#808080',
                        fontFamily: 'GothamMedium',
                        fontSize: 12,
                        marginTop: 5,
                        width: '100%'
                    }}
                >
                    {description}
                </Text>
            </View>
            <View style={{ marginRight: 20 }}>
                <Icon name='chevron-right-circle-outline' color='#FE0000' type='material-community' containerStyle={{ paddingHorizontal: 3 }} />
            </View>
        </TouchableOpacity>
    );
});

const AppLinkContainer = props => {
    const backgroundColor = props.json?.backgroundColor ?? '#ededed';
    // const backgroundImage = props.json?.backgroundImage;
    const links = props.contentItems;
    const linksArray = Object.values(links || {});

    const renderLink = item => <AppLink json={item} key={item.id} followContentLink={props.followContentLink} />;

    return (
        <View
            style={{
                backgroundColor: backgroundColor || '#f5f5f5',
                flex: 1
            }}
            testID='AppLinkContainer'
        >
            <View style={{ justifyContent: 'center', width: '100%', height: '100%' }}>{linksArray.map(link => renderLink(link))}</View>
        </View>
    );
};

AppLinkContainer.propTypes = {
    backgroundColor: PropTypes.string,
    backgroundImage: PropTypes.object,
    contentItems: PropTypes.object.isRequired
};

export default AppLinkContainer;
